class Config {

    get ngxSigGallery() {
        return this.getValue('ngxSigGallery') || {} ;
    }

    get ngxCustomPreviewCarousel() {
        return this.getValue('ngxCustomPreviewCarousel') || {} ;
    }

    get ngxSolrPreviewCarousel() {
        return this.getValue('ngxSolrPreviewCarousel') || {} ;
    }

    get ngxProductsCarousel() {
        return this.getValue('ngxProductsCarousel') || {} ;
    }

    get entityForm() {
        return this.getValue('entityForm') || {} ;
    }

    get ngxSearch() {
        return this.getValue('ngxSearch') || {} ;
    }

    get ngxPageRelatedItemPreview() {
        return this.getValue('ngxPageRelatedItemPreview') || {} ;
    }

    get ngxTaxonomyMenuCarausel() {
        return this.getValue('ngxTaxonomyMenuCarausel') || {} ;
    }

    get ngxTaxonomyList() {
        return this.getValue('ngxTaxonomyList') || {} ;
    }

    get ngxPageRelatedMediaPreview() {
        return this.getValue('ngxPageRelatedMediaPreview') || {} ;
    }

    get ngxSolrPreviewTaxonomy() {
        return this.getValue('ngxSolrPreviewTaxonomy') || {} ;
    }

    get ngxPageTabsConfig() {
        return this.getValue('ngxPageTabsConfig');
    }

    get ngxPageAccordionConfig() {
        return this.getValue('ngxPageAccordionConfig');
    }

    get ngxGadgets() {
        return this.getValue('ngxGadgets') || {};
    }

    get ngxTaxonomyMenu() {
        return this.getValue('ngxTaxonomyMenu') || {} ;
    }

    get ngxSolrGroupedPreviewConfig() {
        return this.getValue('ngxSolrGroupedPreviewConfig') || {} ;
    }

    get productTabContexts() {
        return this.getValue('productTabContexts') || {} ;
    }

    get ngxTocConfig() {
        return this.getValue('ngxTocConfig') || {} ;
    }

    get ngxContentTabs() {
        return this.getValue('ngxContentTabs') || {} ;
    }
    get ngxCustomPreviewEntity() {
        return this.getValue('ngxCustomPreviewEntity') || {} ;
    }

    get ngxSwiperjs() {
        return this.getValue('ngxSwiperjs') || {} ;
    }

    get ngxReportCharts() {
        return this.getValue('ngxReportCharts') || {} ;
    }
    
    get ngxRevision() {
        return this.getValue('ngxRevision') || {} ;
    }

    getValue(componentName?) {
        return (<any>window).EntityConfig?.[componentName];
    }


    setValue(key, value) {
        // if(!(<any>window).EntityConfig) {
        //     (<any>window).EntityConfig = {};
        // }
        (<any>window).EntityConfig[key] = value;
    }

}

if (!(<any>window).EntityConfig) {
    (<any>window).EntityConfig = {
        // this is so that the 'key' property of each of the followings could be defined directly:
        ngxSigGallery: {},
        ngxCustomPreviewCarousel: {},
        ngxSolrPreviewCarousel: {},
        ngxProductsCarousel: {},
        entityForm: {},
        ngxSearch: {},
        ngxPageRelatedItemPreview: {},
        ngxTaxonomyMenuCarausel: {},
        ngxTaxonomyList: {},
        ngxPageRelatedMediaPreview: {},
        ngxSolrPreviewTaxonomy: {},
        ngxPageTabsConfig: {},
        ngxPageAccordionConfig: {},
        ngxGadgets: {},
        ngxTaxonomyMenu: {},
        ngxSolrGroupedPreviewConfig: {},
        productTabContexts: {},
        ngxTocConfig: {},
        ngxContentTabs: {},
        ngxCustomPreviewEntity: {},
        ngxSwiperjs: {},
        ngxReportCharts: {},
        ngxRevision: {}
    };
}

const EntityConfig = new Config();
export { EntityConfig };


